import { useState, useEffect, useCallback } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import General from "./General";

const TABS = [
    { key: "general", label: "General" },
    { key: "notifications", label: "Notifications" },
    { key: "personalization", label: "Personalization" },
    { key: "security", label: "Security" },
    { key: "account", label: "Account" },
];

const SettingsModal = ({
    account_id,
    show,
    handleClose,
    fetchRecords,
    userData,
}) => {
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        message: "",
        display: false,
    });
    const [activeTab, setActiveTab] = useState("general");

    // General
    const [appearance, setAppearance] = useState("system")
    const [language, setLanguage] = useState("auto")

    useEffect(() => {
        if (userData) {
            // Initialize form state here if needed
        }
    }, [userData]);

    const resetState = () => {
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
        setActiveTab("general");
    };

    const closeModal = useCallback(() => {
        resetState();
        handleClose();
    }, [handleClose]);

    return (
        <Modal show={show} onHide={closeModal} centered className="settings_modal">
            <Modal.Body className="p-0">

                <div className="settings_modal_layout">
                    <aside className="settings_modal_sidebar">
                        <div className="settings_modal_sidebar_header">
                            <button
                                type="button"
                                onClick={closeModal}
                                aria-label="Close settings"
                            >
                                <i className="fa-solid fa-x" />
                            </button>
                        </div>

                        {TABS.map((tab) => (
                            <button
                                key={tab.key}
                                type="button"
                                className={`settings_modal_sidebar_link ${activeTab === tab.key
                                    ? "settings_modal_sidebar_link_selected"
                                    : ""
                                    }`}
                                onClick={() => setActiveTab(tab.key)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </aside>

                    <section className="settings_modal_content">
                        <div className="settings_modal_content_header">
                            {TABS.find((tab) => tab.key === activeTab)?.label}
                        </div>

                        <div className="settings_modal_content_body">
                            {activeTab == "general" ? (
                                <General setAppearance={setAppearance} setLanguage={setLanguage} />
                            ) : (
                                <div>Other</div>
                            )}
                        </div>

                        {errorMessage.display && (
                            <div className="settings_modal_error">
                                {errorMessage.message}
                            </div>
                        )}
                    </section>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SettingsModal;